import {Button, Icon, Illustration, Typography} from '@sollapay/ui/components';
import {DesktopOnlyIllustration} from '@sollapay/ui/illustrations';
import {useCopyToClipboard} from '@sollapay/web-core';
import {useTranslation} from 'react-i18next';

import type {FC} from 'react';

export const DesktopOnlyScreen: FC = () => {
  const {t} = useTranslation('common');
  const {copy} = useCopyToClipboard();

  return (
    <div className="bg-background flex min-h-screen flex-col items-center justify-center gap-6 px-6 text-center">
      <Illustration width={166} height={130}>
        <DesktopOnlyIllustration />
      </Illustration>
      <div className="flex flex-col gap-2">
        <Typography size="lg" weight="semibold">
          {t('deviceCompatibility.title')}
        </Typography>
        <Typography size="sm" color="secondary" className="whitespace-normal">
          {t('deviceCompatibility.description')}
        </Typography>
      </div>
      <Button
        variant="secondary"
        iconPosition="start"
        icon={<Icon name="link" />}
        onClick={() => copy(window.location.href)}
      >
        {t('deviceCompatibility.sendLinkButton')}
      </Button>
      <Typography size="xs" color="tertiary">
        {t('deviceCompatibility.footerNote')}
      </Typography>
    </div>
  );
};
